// extracted by mini-css-extract-plugin
export default {"list":"AuthNav_list__hFVT+","item":"AuthNav_item__bmR6y","link":"AuthNav_link__pW2Ra","icon":"AuthNav_icon__ZCGLu","active":"AuthNav_active__DVXLs"};